import { ArrowRight, Clock, MapPin, Phone, Video } from 'lucide-react';
import { cn } from '@/lib/utils';

const FORMAT_ICONS = { online: Video, 'in-person': MapPin, phone: Phone };

// Step 1 — meeting type selection. Types come from the backend (centrally
// managed data); only genuinely active types are shown.
export const MeetingTypeStep = ({ meetingTypes, selected, onSelect, onNext }) => (
  <div data-testid="booking-step-type">
    <h3 className="text-xl font-extrabold tracking-tight text-navy-900">Choose a meeting type</h3>
    <div className="mt-6 space-y-4" role="radiogroup" aria-label="Meeting type">
      {meetingTypes.map((mt) => {
        const active = selected?.meetingTypeId === mt.meetingTypeId;
        return (
          <button
            key={mt.meetingTypeId}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onSelect(mt)}
            data-testid={`meeting-type-${mt.meetingTypeId}`}
            className={cn(
              'w-full rounded-xl border-2 p-6 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy-900 focus-visible:ring-offset-2',
              active ? 'border-navy-900 bg-navy-50' : 'border-slate-200 bg-white hover:border-navy-300'
            )}
          >
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <span className="text-lg font-extrabold tracking-tight text-navy-900">{mt.name}</span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-mist px-3 py-1 text-xs font-bold text-navy-800">
                <Clock className="h-3.5 w-3.5" aria-hidden="true" />
                {mt.durationMinutes} minutes
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-mist px-3 py-1 text-xs font-bold text-navy-800">
                {(() => {
                  const FormatIcon = FORMAT_ICONS[mt.format] || Video;
                  return <FormatIcon className="h-3.5 w-3.5" aria-hidden="true" />;
                })()}
                {mt.location}
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{mt.description}</p>
          </button>
        );
      })}
    </div>
    <div className="mt-8 flex justify-end">
      <button
        type="button"
        onClick={onNext}
        disabled={!selected}
        data-testid="booking-next-type"
        className="group inline-flex items-center gap-2 rounded-md bg-navy-900 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-navy-700 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Choose Date &amp; Time
        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
      </button>
    </div>
  </div>
);
